import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { RouteHistory } from 'app/models/route-history.model';
import { Shift, ShiftContainer, ShiftContainerRequest } from 'app/models/shift.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RouteHistoryService {

    routeHistory: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getRouteHistory(driverProcessId: number): Promise<Array<RouteHistory>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "RouteHistory/GetRouteHistory?driverProcessId=" + driverProcessId)
                .subscribe((response: any) => {
                    this.routeHistory = response;
                    this.onChanged.next(this.routeHistory);
                    resolve(response);
                }, reject);
        });
    }

}
